import { ClassicEditor as ClassicEditorBase, InlineEditor as InlineEditorBase } from '@eworx/ckeditor5';

import plugins from './Plugins';
import de from './translations/de';
import en from './translations/en';

ClassicEditorBase.builtinPlugins = [
    ...ClassicEditorBase.builtinPlugins,
    ...plugins,
];
InlineEditorBase.builtinPlugins = [
    ...InlineEditorBase.builtinPlugins,
    ...plugins,
];

ClassicEditorBase.defaultConfig.translations = [de, en];
InlineEditorBase.defaultConfig.translations = [de, en];
ClassicEditorBase.defaultConfig.language = localStorage.user_ui_lang;
InlineEditorBase.defaultConfig.language = localStorage.user_ui_lang;

class ClassicEditor extends ClassicEditorBase {
}
class InlineEditor extends InlineEditorBase {
}

// all exports will be available via "CKEDITOR5"
// see 'library' in webpack config
export { ClassicEditor, InlineEditor };
export { instances } from '@eworx/ckeditor5';
